import React, { PureComponent } from 'react';
import {
  WithStyles,
  createStyles,
  withStyles,
  Theme,
} from '@lifeomic/chroma-react/styles';
import withIsMobile, {
  WithIsMobileInjectedProps,
} from '../../../../hoc/withIsMobile';
import SurveyItem from '../../util/SurveyItem';
import clsx from 'clsx';
import Root from './Root';
import SurveyPageHeader from './SurveyPageHeader';
import { Divider } from '@mui/material';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      minHeight: '100%',
    },
    paper: {
      background: theme.palette.common.white,
      overflowX: 'auto',
    },
    itemsContainer: {
      width: '100%',
      overflowX: 'auto',
      flex: 1,
    },
    controlContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      marginTop: theme.spacing(3),
      padding: theme.spacing(4),
      paddingTop: theme.spacing(2),
    },
    mobileControlContainer: {
      padding: 0,
    },
    divider: {
      marginTop: theme.spacing(3),
    },
  });

export interface SurveyLayoutOwnProps {
  isPaginated: boolean;
  surveyContent: any;
  leftButton?: any;
  draftButton: any;
  rightButton: any;
  surveyItem?: SurveyItem;
}

export type SurveyLayoutProps = SurveyLayoutOwnProps &
  WithStyles<typeof styles> &
  WithIsMobileInjectedProps;

class SurveyLayout extends PureComponent<SurveyLayoutProps> {
  render() {
    const {
      surveyContent,
      leftButton,
      draftButton,
      rightButton,
      surveyItem,
      isMobile,
      classes,
    } = this.props;

    return (
      <>
        <Root isMobile={isMobile}>
          {surveyItem && <SurveyPageHeader surveyItem={surveyItem} />}
          <div className={classes.itemsContainer}>{surveyContent}</div>
          {isMobile && (rightButton || leftButton) && (
            <>
              <Divider className={classes.divider} />
              <div
                className={clsx(
                  classes.controlContainer,
                  classes.mobileControlContainer,
                )}
              >
                {rightButton}
                {draftButton}
                {leftButton}
              </div>
            </>
          )}
        </Root>
        {!isMobile && (
          <div className={classes.controlContainer}>
            {rightButton}
            {draftButton}
            {leftButton}
          </div>
        )}
      </>
    );
  }
}

export default withStyles(styles)(withIsMobile(SurveyLayout));
